import { ANIMATION_VARIATIONS_FRAMES } from '@/map-phaser-new/constants'
import type { AnimationsData } from '@/map-phaser-new/interfaces'

export const skierRightAnimations: AnimationsData[] = [
  {
    animationCreationData: {
      animationName: 'skierRightAnimations1',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '09',
      delay: 0,
      duration: 300,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 9,
        end: 7,
        zeroPad: 2,
      },
    },
  },
  {
    animationCreationData: {
      animationName: 'skierRightAnimations2',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '07',
      delay: 0,
      duration: 300,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 7,
        end: 6,
        zeroPad: 2,
      },
    },
  },
  {
    animationCreationData: {
      animationName: 'skierRightAnimations3',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '06',
      delay: 0,
      duration: 700,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 6,
        end: 7,
        zeroPad: 2,
      },
    },
  },
  {
    animationCreationData: {
      animationName: 'skierRightAnimations4',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '07',
      delay: 0,
      duration: 400,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 7,
        end: 6,
        zeroPad: 2,
      },
    },
  },
]
